import React from "react";

const Rules = () => {
  return (
    <div className="wholeDiv">
      <div className="titleText">
        <b>Server Rules</b>
      </div>
      <div className="helpDescription">
        <b>Rules for players to promote a fun and fair gaming environment</b>
      </div>
      <div className="textBox">
        <div className="perkDescr">
          <div className="benefitsBoldedText"> General Rules</div>
          <div className="dotBoldedTextSmaller">___</div>
          To ensure a fun, fair, and respectful experience for everyone, we've
          set the following rules for this server. These guidelines help
          maintain a positive community where players can enjoy the game without
          disruption. Please note that rules may be updated at any time, so make
          sure to check back periodically.
        </div>
        <div className="listText">
          <ol>
            <li>
              <b>No Cheating or Exploits. </b>
              Any use of hacks, cheats, or map exploits is strictly prohibited.
            </li>
            <li>
              <b>No Racism, Hate Speech, or Discrimination. </b>
              Respect all players. Slurs, racism, sexism, homophobia, or any
              form of hate speech will result in an immediate ban.
            </li>
            <li>
              <b>Be Respectful. </b>
              Treat others the way you want to be treated. Harassment, griefing,
              or toxic behavior won't be tolerated.
            </li>
            <li>
              <b>No Mic/Chat Spam. </b>
              Keep voice and text chat clear of spam or disruptive noises.
              Excessive shouting, music, or trolling is not allowed.
            </li>
            <li>
              <b>Play as a Team. </b>
              Killing Floor is cooperative. Don't intentionally sabotage or
              leave teammates behind.
            </li>
            <li>
              <b>No AFK Farming. </b>
              Players who go AFK to farm XP or cash may be kicked without
              warning.
            </li>
            <li>
              <b>Use English in Public Chat. </b>
              To keep communication clear for all, please use English in voice
              and text chat.
            </li>
            <li>
              <b>Respect Admin Decisions. </b>
              If a moderator or admin gives you a warning, follow it. Repeat
              offenders will be punished.
            </li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default Rules;
